import React from 'react';

export default function Toast({ toast }) {
  if (!toast) return null;
  const base =
    'fixed left-1/2 -translate-x-1/2 bottom-6 z-[1000] rounded px-4 py-2 shadow-lg text-white';
  const color =
    toast.type === 'error' ? 'bg-red-600' : toast.type === 'warn' ? 'bg-amber-600' : 'bg-green-600';
  return (
    <div className={`${base} ${color}`}>
      <span className="text-sm">{toast.message}</span>
    </div>
  );
}
